import { lazy } from "react"

const RetiredPlayersPage$$__react__lazy__component = lazy(() => 
    import("./RetiredPlayersPage__original__module.mjs")
        .then(module => module.get_$$RetiredPlayersPage$$RetiredPlayersPage$$react__component$$37xlmtdd1zu8q())
        .then(component => ({ default: component }))
)

export const get_$$RetiredPlayersPage$$RetiredPlayersPage$$react__component$$37xlmtdd1zu8q = () => RetiredPlayersPage$$__react__lazy__component